import { dew as _enDew } from "./locales/en";
import { dew as _chronoDew } from "./chrono";
import { dew as _deDew } from "./locales/de";
import { dew as _frDew } from "./locales/fr";
import { dew as _jaDew } from "./locales/ja";
import { dew as _ptDew } from "./locales/pt";
import { dew as _nlDew } from "./locales/nl";
import { dew as _zhDew } from "./locales/zh";
import { dew as _ruDew } from "./locales/ru";
import { dew as _esDew } from "./locales/es";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function () {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.parseDate = exports.parse = exports.casual = exports.strict = exports.es = exports.ru = exports.zh = exports.nl = exports.pt = exports.ja = exports.fr = exports.de = exports.Weekday = exports.Meridiem = exports.Chrono = exports.en = void 0;
  const en = __importStar(_enDew());
  exports.en = en;
  const chrono_1 = _chronoDew();
  Object.defineProperty(exports, "Chrono", {
    enumerable: true,
    get: function () {
      return chrono_1.Chrono;
    }
  });
  var Meridiem;
  (function (Meridiem) {
    Meridiem[Meridiem["AM"] = 0] = "AM";
    Meridiem[Meridiem["PM"] = 1] = "PM";
  })(Meridiem = exports.Meridiem || (exports.Meridiem = {}));
  var Weekday;
  (function (Weekday) {
    Weekday[Weekday["SUNDAY"] = 0] = "SUNDAY";
    Weekday[Weekday["MONDAY"] = 1] = "MONDAY";
    Weekday[Weekday["TUESDAY"] = 2] = "TUESDAY";
    Weekday[Weekday["WEDNESDAY"] = 3] = "WEDNESDAY";
    Weekday[Weekday["THURSDAY"] = 4] = "THURSDAY";
    Weekday[Weekday["FRIDAY"] = 5] = "FRIDAY";
    Weekday[Weekday["SATURDAY"] = 6] = "SATURDAY";
  })(Weekday = exports.Weekday || (exports.Weekday = {}));
  const de = __importStar(_deDew());
  exports.de = de;
  const fr = __importStar(_frDew());
  exports.fr = fr;
  const ja = __importStar(_jaDew());
  exports.ja = ja;
  const pt = __importStar(_ptDew());
  exports.pt = pt;
  const nl = __importStar(_nlDew());
  exports.nl = nl;
  const zh = __importStar(_zhDew());
  exports.zh = zh;
  const ru = __importStar(_ruDew());
  exports.ru = ru;
  const es = __importStar(_esDew());
  exports.es = es;
  exports.strict = en.strict;
  exports.casual = en.casual;
  function parse(text, ref, option) {
    return exports.casual.parse(text, ref, option);
  }
  exports.parse = parse;
  function parseDate(text, ref, option) {
    return exports.casual.parseDate(text, ref, option);
  }
  exports.parseDate = parseDate;
  //# sourceMappingURL=index.js.map
  return exports;
}